import { 
  TICKET_SUPORTE_FETCHED,
  TICKET_SUPORTE_CREATED,
  TICKET_SUPORTE_UPDATED,
  TICKET_INTERACOES_REQUEST_STARTED,
  TICKET_INTERACOES_FETCHED,
  TICKET_INTERACOES_REQUEST_ERROR,
  TICKET_INTERACAO_ADD_STARTED,
  TICKET_INTERACAO_ADDED_SUCCESS,
  TICKET_INTERACAO_ADD_ERROR
} from './ticketSuporteActions';

const INITIAL_STATE = {
  list: [], // Lista de tickets
  currentTicketInteractions: {
    ticketId: null,
    data: [],
    loading: false,
    error: null,
    adding: false,
    addError: null,
  }
  // Adicionar outros estados se necessário (ex: totalItems, currentPage para paginação)
  // currentTicket: null, // Para visualizar/editar um ticket específico
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TICKET_SUPORTE_FETCHED:
      // Ajustado para action.payload ser o array de tickets diretamente,
      // ou action.payload.data se a API retornar um objeto com uma chave 'data'.
      // O || [] garante que list seja sempre um array.
      const newList = Array.isArray(action.payload) ? action.payload : (action.payload && action.payload.data);
      return {
        ...state,
        list: newList || [],
        // Se sua API tiver metadados de paginação em action.payload.meta (quando não for array direto):
        // totalItems: newList ? (action.payload.meta && action.payload.meta.totalItems) || 0 : 0,
        // currentPage: newList ? (action.payload.meta && action.payload.meta.currentPage) || 1 : 1,
      };
    case TICKET_SUPORTE_CREATED:
      // A recarga da lista é feita no componente após o sucesso,
      // então não precisamos adicionar o ticket aqui manualmente para evitar duplicidade
      // ou complexidade de manter a ordem correta sem recarregar.
      return state; // Ou recarregue a lista se preferir um comportamento diferente.
    case TICKET_SUPORTE_UPDATED:
      if (!action.payload || !action.payload.id) {
        return state;
      }
      return { 
        ...state, 
        list: state.list.map(ticket => 
          ticket.id === action.payload.id ? action.payload : ticket
        ),
      };
    // Cases para interações
    case TICKET_INTERACOES_REQUEST_STARTED:
      return {
        ...state,
        currentTicketInteractions: {
          ...state.currentTicketInteractions,
          ticketId: action.payload.ticketId,
          loading: true,
          error: null,
          data: [], // Limpa dados antigos ao iniciar nova busca
        }
      };
    case TICKET_INTERACOES_FETCHED:
      // Verifica se o ticketId do payload corresponde ao ticketId da requisição em andamento
      if (state.currentTicketInteractions.ticketId === action.payload.ticketId) {
        return {
          ...state,
          currentTicketInteractions: {
            ...state.currentTicketInteractions,
            data: action.payload.interacoes || [],
            loading: false,
            error: null,
          }
        };
      }
      return state; // Se o ticketId não corresponder, ignora (pode ser de uma requisição antiga)
      
    case TICKET_INTERACOES_REQUEST_ERROR:
      if (state.currentTicketInteractions.ticketId === action.payload.ticketId) {
        return {
          ...state,
          currentTicketInteractions: {
            ...state.currentTicketInteractions,
            loading: false,
            error: action.payload.error,
          }
        };
      }
      return state;
    // Cases para adicionar interação
    case TICKET_INTERACAO_ADD_STARTED:
      if (state.currentTicketInteractions.ticketId === action.payload.ticketId) {
          return {
            ...state,
            currentTicketInteractions: {
              ...state.currentTicketInteractions,
              adding: true,
              addError: null,
            }
          };
      }
      return state;

    case TICKET_INTERACAO_ADDED_SUCCESS:
      // Verifica se a interação pertence ao ticket atualmente visualizado
      if (state.currentTicketInteractions.ticketId === action.payload.ticketId) {
        return {
          ...state,
          currentTicketInteractions: {
            ...state.currentTicketInteractions,
            // Adiciona a nova interação à lista existente (assumindo que queremos ver em ordem cronológica, nova por último)
            data: [...state.currentTicketInteractions.data, action.payload.interacao],
            adding: false,
          }
        };
      }
      return state; // Se for de outro ticket, não faz nada aqui

    case TICKET_INTERACAO_ADD_ERROR:
      if (state.currentTicketInteractions.ticketId === action.payload.ticketId) {
        return {
          ...state,
          currentTicketInteractions: {
            ...state.currentTicketInteractions,
            adding: false,
            addError: action.payload.error,
          }
        };
      }
      return state;
    // TODO: Adicionar cases para TICKET_SUPORTE_DELETED, TICKET_SUPORTE_ERROR etc.
    default:
      return state;
  }
}; 